import { useState } from "react";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { KnowledgeBaseFacts } from "@/components/kb/KnowledgeBaseFacts";
import { KnowledgeBaseDocs } from "@/components/kb/KnowledgeBaseDocs";

export function KnowledgeBaseManager() {
  const [tab, setTab] = useState<"facts" | "docs">("facts");

  return (
    <Card className="border-border/60 shadow-sm overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between gap-4">
        <div>
          <CardTitle>Knowledge Base</CardTitle>
          <p className="text-sm text-muted-foreground mt-1">
            Truth layer for pricing/schedule/policies. Fill required facts before <code>AGENT_MODE=live</code>.
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant={tab === "facts" ? "default" : "outline"} onClick={() => setTab("facts")}>
            Facts
          </Button>
          <Button variant={tab === "docs" ? "default" : "outline"} onClick={() => setTab("docs")}>
            Docs
          </Button>
        </div>
      </CardHeader>

      {tab === "facts" ? <KnowledgeBaseFacts /> : <KnowledgeBaseDocs />}
    </Card>
  );
}

